/**
 * Copyright (c) 2018-present clchart Contributors.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// 以下是 ClDrawZLine 的实体定义
// 画折线

import {
    _drawBegin,
    _drawEnd,
    _drawmoveTo,
    _drawlineTo
} from './cl.draw'
import {
    initCommonInfo,
    getLineColor
} from './cl.chart.init'
import {
    inRect,
    getRectY
} from '../cl.utils'

import { getValue } from '../datas/cl.data'

/**
 * Class representing ClDrawZLine
 * @export
 * @class ClDrawZLine
 */
export default class ClDrawZLine {
    /**

     * Creates an instance of ClDrawZLine.
     * @param {Object} father
     * @param {Object} rectMain
     */
    constructor(father, rectMain) {
        initCommonInfo(this, father)
        this.rectMain = rectMain

        this.father = father

    }
    /**
     * paint
     * @param {String} key
     * @memberof ClDrawZLine
     */
    onPaint(key) {
        this.dataLayer = this.father.father.dataLayer
        this.linkInfo = this.dataLayer.linkInfo
        this.axisYdata = this.father.axisYdata

        if (key !== undefined) this.hotKey = key
        this.data = this.father.father.getData(this.hotKey)

        // console.log('=====', this.linkInfo.minIndex, this.info.alone, this.data);
        if (this.info.fieldX === undefined) this.info.fieldX = 'index'
        if (this.info.fieldY === undefined) this.info.fieldY = 'value'

        let xx, yy, val, kidx
        let clr
        if (this.info.color === undefined) {
            clr = getLineColor(this.info.colorIndex)
        } else {
            clr = this.color[this.info.color]
        }

        let isBegin = false
        _drawBegin(this.context, clr)
        for (let k = 0, idx = this.linkInfo.minIndex; idx <= this.linkInfo.maxIndex; k++, idx++) {
            if (this.info.alone) {
                val = getValue(this.data, this.info.fieldY, idx)
            } else {
                val = getValue(this.data, this.info.fieldY, k)
            }
            xx = this.rectMain.left + (k + 0.5) * (this.linkInfo.unitX + this.linkInfo.spaceX)
            yy = this.rectMain.top + Math.floor((this.axisYdata.max - val) * this.axisYdata.unitY)
            // yy = this.rectMain.top + Math.floor((this.axisYdata.max - val) * this.axisYdata.unitY)
            if (this.info.skipfd !== undefined) {
                if (this.info.alone) {
                    kidx = getValue(this.data, this.info.skipfd, idx)
                } else {
                    kidx = getValue(this.data, this.info.skipfd, k)
                }
                if (kidx === 0) {
                    // console.log(kidx, this.info.skipfd, this.data, this.info.alone);
                    _drawmoveTo(this.context, xx, yy)
                    continue
                }
            }
            if (!isBegin) {
                isBegin = inRect(this.rectMain, {
                    x: xx,
                    y: yy
                })
                if (!isBegin) {
                    yy = getRectY(this.rectMain, yy)
                    _drawmoveTo(this.context, xx, yy)
                    continue
                }
            } else {
                
                if (!inRect(this.rectMain, {
                    x: xx,
                    y: yy
                })) {
                    isBegin = false
                    yy = getRectY(this.rectMain, yy)
                }
            }
            _drawlineTo(this.context, xx, yy)
        }
        _drawEnd(this.context)
    }
}